import { Button, Grid, Space } from "antd-mobile"
import { useCallback, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { VictoryPie } from "victory"
import { DATA_TYPE, getDataByDate } from "../../api/userData"

const defaultData = [
  { x: " ", y: 0 },
  { x: " ", y: 0 },
]

const dailyKCAL = 3000 // TODO need use profile data
const dailyWater = 2500 // TODO need use profile data

export const WATER_COLOR = "#3fd2e4" // TODO move to constans
export const FOOD_COLOR = "#86D27B"

function WaterIcon() {
  return (
    <svg width="50" height="50" viewBox="0 0 24 24">
      <polygon
        fill="none"
        stroke={WATER_COLOR}
        strokeMiterlimit="10"
        strokeWidth="1.2"
        points="17.73 22.5 6.27 22.5 3.41 1.5 20.59 1.5 17.73 22.5"
      />
      <path
        fill="none"
        stroke={WATER_COLOR}
        strokeMiterlimit="10"
        strokeWidth="1.2"
        d="M19.68,8.18C12,10.09,12,5.32,4.32,8.18"
      />
    </svg>
  )
}

function ForkIcon() {
  return (
    <svg width="50" height="50" viewBox="0 0 512 512">
      <g>
        <path
          fill={FOOD_COLOR}
          d="M207.103,23.875v109.219c0,7-5.656,12.641-12.625,12.641h-3.375c-6.969,0-12.641-5.641-12.641-12.641V23.375
  c0-18-12.109-23.375-23.719-23.375s-23.719,5.375-23.719,23.375v109.719c0,7-5.672,12.641-12.641,12.641h-3.375
  c-6.969,0-12.625-5.641-12.625-12.641V23.875c0-32.219-45.938-31.125-45.938,0.359c0,37.703,0,104.297,0,104.297
  c-0.219,57.906,13.625,72.953,36.469,91c18.422,14.531,34.156,22.859,34.156,58.953v232.188h55.344V278.484
  c0-36.094,15.734-44.422,34.156-58.953c22.859-18.047,36.688-33.094,36.469-91c0,0,0-66.594,0-104.297
  C253.04-7.25,207.103-8.344,207.103,23.875z"
        />
        <path
          fill={FOOD_COLOR}
          d="M385.228,34.75c-11.75,32.953-45.578,110.156-47.719,178.344c-3.313,105.844,61.547,90.188,62.703,159.531
  v138.688h55.078l0.266,0.688c0,0,0-0.281,0-0.688c0-9.266,0-119.625,0-232.203c0-111.359,0-224.797,0-244.359
  C455.556-5.438,403.524-16.531,385.228,34.75z"
        />
      </g>
    </svg>
  )
}

function Tracker() {
  const date = new Date().toLocaleDateString()
  const [kcal, setCkal] = useState(0)
  const [water, setWater] = useState(0)

  const [dataFoot, setDataFoot] = useState(defaultData)
  const [dataWater, setDataWater] = useState(defaultData)

  useEffect(() => {
    let totalCal = 0
    let totalWater = 0
    getDataByDate(DATA_TYPE.DIET, date)?.forEach((item) => {
      const [, cal] = String(item.name).split("|")
      totalCal += (Number(cal) * item.weight) / 100
    })
    getDataByDate(DATA_TYPE.WATER, date)?.forEach((item) => {
      totalWater += Number(item.value)
    })

    setDataFoot([
      { x: " ", y: (totalCal / dailyKCAL) * 100 },
      { x: " ", y: 100 - (totalCal / dailyKCAL) * 100 },
    ])

    setDataWater([
      { x: " ", y: (totalWater / dailyWater) * 100 },
      { x: " ", y: 100 - (totalWater / dailyWater) * 100 },
    ])

    setCkal(totalCal)
    setWater(totalWater)
  }, [date])

  const navigate = useNavigate()

  const onClick = useCallback(
    (path) => {
      navigate(path)
    },
    [navigate]
  )

  return (
    <Grid
      columns={12}
      gap={12}
      style={{
        // marginLeft: 16,
        // marginRight: 16,
        width: "100%",
      }}
    >
      <Grid.Item span={12}>
        <div style={{ display: "flex" }}>
          <div style={{ margin: "auto" }}>
            <svg width={400} height={400}>
              <VictoryPie
                colorScale={[FOOD_COLOR, "#e1e1e1"]}
                standalone={false}
                width={400}
                height={400}
                innerRadius={160}
                cornerRadius={25}
                data={dataFoot}
              />
              <svg x={5} y={5}>
                <VictoryPie
                  colorScale={[WATER_COLOR, "#e1e1e1"]}
                  standalone={false}
                  width={390}
                  height={390}
                  innerRadius={134}
                  cornerRadius={10}
                  data={dataWater}
                />
              </svg>

              <text x="180" y="130" fill="black">
                сегодня
              </text>
              <text x="240" y="130" fill="black">
                норма
              </text>

              <text x="100" y="160" fill={FOOD_COLOR}>
                КАЛОРИИ
              </text>
              <text x="204" y="160" fill={FOOD_COLOR} textAnchor="middle">
                {kcal}
              </text>
              <text x="240" y="160" fill={FOOD_COLOR}>
                2230 ккал
              </text>

              <text x="100" y="180" fill="black">
                жиры
              </text>
              <text x="204" y="180" fill="black" textAnchor="middle">
                0
              </text>
              <text x="240" y="180" fill="black">
                74 г
              </text>

              <text x="100" y="200" fill="black">
                белки
              </text>
              <text x="204" y="200" fill="black" textAnchor="middle">
                0
              </text>
              <text x="240" y="200" fill="black">
                167 г
              </text>

              <text x="100" y="220" fill="black">
                углеводы
              </text>
              <text x="204" y="220" fill="black" textAnchor="middle">
                0
              </text>
              <text x="240" y="220" fill="black">
                223 г
              </text>

              <text x="100" y="240" fill={WATER_COLOR}>
                ВОДА
              </text>
              <text x="204" y="240" fill={WATER_COLOR} textAnchor="middle">
                {water}
              </text>
              <text x="240" y="240" fill={WATER_COLOR}>
                3250 мл
              </text>
            </svg>
          </div>
        </div>
      </Grid.Item>
      <Grid.Item span={6} style={{ marginTop: -90 }}>
        <Button
          block
          color="primary"
          fill="none"
          onClick={() => onClick("/drank")}
        >
          <div style={{ paddingRight: 70 }}>
            <WaterIcon />
            <p style={{ margin: 0, color: WATER_COLOR }}>+ Выпил</p>
          </div>
        </Button>
      </Grid.Item>
      <Grid.Item span={6} style={{ marginTop: -90 }}>
        <Button
          block
          color="primary"
          fill="none"
          onClick={() => onClick("/ate")}
        >
          <div style={{ paddingLeft: 70 }}>
            <ForkIcon />
            <p style={{ margin: 0, color: FOOD_COLOR }}>+ Съел</p>
          </div>
        </Button>
      </Grid.Item>
      <Grid.Item span={12} style={{ marginLeft: 16, marginRight: 16 }}>
        <Space />
        <Button
          block
          color="success"
          fill="solid"
          size="large"
          onClick={() => onClick("/myDiet")}
        >
          Мой рацион
        </Button>
      </Grid.Item>
      <Grid.Item span={12} style={{ marginLeft: 16, marginRight: 16 }}>
        <Space />
        <Button
          block
          color="success"
          fill="outline"
          size="large"
          onClick={() => onClick("/statistic")}
        >
          Статистика
        </Button>
      </Grid.Item>
      <Grid.Item span={12} style={{ marginLeft: 16, marginRight: 16 }}>
        <div style={{ textAlign: 'center', marginTop: 24}}>
          <a href="https://deta-d8458.web.app/policy.html" target="_blank" rel="noreferrer">
            политика конфиденциальности
          </a>
        </div>
      </Grid.Item>
    </Grid>
  )
}

export default Tracker
